var map = {
	"./ai/6.svg": 525,
	"./computernaya-gramotnost/6.svg": 526,
	"./ege-informatika/6.svg": 527,
	"./frontend/6.svg": 528,
	"./game-design/6.svg": 529,
	"./graphic-design-pro/6.svg": 530,
	"./graphic-design/6.svg": 531,
	"./intensive/6.svg": 532,
	"./osnovy-programmirovaniya/6.svg": 533,
	"./predprinimatelstvo/6.svg": 534,
	"./python/6.svg": 535,
	"./scratch/6.svg": 536,
	"./unity/6.svg": 537,
	"./videoblogging/6.svg": 538,
	"./web-razrabotka/6.svg": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;